module.exports = __webpack_public_path__ + "static/enhanceyourbusiness-f18fdab647ccd45e7a6c67630e93bf26.svg";